import { Card } from 'primereact/card';
import React from 'react';
import { MainCardProps } from '@interfaces/interfaces';

export const SectionCard: React.FC<MainCardProps> = ({ children }) => {
  return <Card className="mainCard">{children}</Card>;
};
